export const MINIMUM_MISSION_LIMIT = 'minimumMissionLimit'
export const WEEKLY_MISSION_LIMIT = 'weeklyMissionLimit'

export const CAMPAIGN_COSTS = [
  {
    key: 'h2hDistributionCosts',
    label: 'H2H Distribution',
    description: 'Distribution cost for H2H missions.',
    type: 'currency',
  },
  {
    key: 'd2dDistributionCosts',
    label: 'D2D Distribution',
    description: 'Distribution cost for D2D missions.',
    type: 'currency',
  },
  {
    key: 'bonusBa',
    label: 'BA Bonus',
    description: 'BA bonus cost per conversion.',
    type: 'currency',
  },
  {
    key: 'baPayout',
    label: 'BA Payout',
    description: 'BA earnings. How much a BA is paid for a mission.',
    type: 'currency',
  },
  {
    key: 'outfitCosts',
    label: 'Outfit',
    description: 'Cost of an average outfit pack.',
    type: 'currency',
  },
  {
    key: 'permitCostsH2h',
    label: 'Permit (H2H)',
    description: 'Cost of a permit H2H.',
    type: 'currency',
  },
  {
    key: 'permitCostsD2d',
    label: 'Permit (D2D)',
    description: 'Cost of a permit D2D.',
    type: 'currency',
  },
  {
    key: 'travelCosts',
    label: 'Travel',
    description: 'Travel cost per mission.',
    type: 'currency',
  },
]

export const CAMPAIGN_LIMITS = [
  {
    key: MINIMUM_MISSION_LIMIT,
    label: 'Minimum Mission Limit',
    description:
      'The min number of missions requried, per selected city, to create a campaign.',
    type: 'number',
  },
  {
    key: WEEKLY_MISSION_LIMIT,
    label: 'Weekly Mission Limit',
    description:
      'Max number of missions per week that can be booked in a campaign through self-serve. Leave blank for unlimited.',
    type: 'number',
  },
  {
    key: 'flyerPackH2h',
    label: 'H2H Flyer Pack',
    description: 'The number of flyers in a H2H flyer pack.',
    type: 'number',
  },
  {
    key: 'flyerPackD2d',
    label: 'D2D Flyer Pack',
    description: 'The number of flyers in a D2D flyer pack.',
    type: 'number',
  },
]

export const TAX_RATE = [
  {
    key: 'countryTaxRate',
    label: 'Country Tax Rate',
    description: 'The effective tax/VAT rate in this country.',
    type: 'percent',
  },
]

export const BA_PER_LOCATION = [
  {
    key: 'baPerLocation',
    label: 'Country BAs per H2H location',
    description:
      'The number of BAs/Distributors for every H2H location added by clients. This affects how many missions we will create for each location. The default recommended value is 1 BA per location.',
    type: 'number',
  },
]

export const DEFAULT_CAMPAIGN_LIMITS = [
  {
    key: 'defaultCampaignLimits',
    label: 'Earliest selectable day (client)',
    description:
      'The earliest number of days, from today, that a client can select a mission date for H2H or campaign launch date for D2D. The shorter the number of days, the less time you as ops will have to review and prepare for the campaign before launch.',
    type: 'number',
    min: 3,
    max: 30,
  },
]

export const BORDER_KEYS = ['name', 'enabledChannelLetterbox', 'travelCosts']

export const CITY_SETTINGS_HEADERS = [
  {
    key: 'name',
    label: 'City',
  },
  // {
  //   key: 'enabledChannelBroadAreas',
  //   label: 'H2H Broad',
  //   type: 'checkbox',
  // },
  {
    key: 'enabledChannelPreciseLocations',
    label: 'H2H Precise',
    type: 'checkbox',
  },
  {
    key: 'enabledChannelLetterbox',
    label: 'D2D',
    type: 'checkbox',
  },
  {
    key: 'h2hDistributionCosts',
    label: 'H2H',
    type: 'currencySign',
  },
  {
    key: 'd2dDistributionCosts',
    label: 'D2D',
    type: 'currencySign',
  },
  {
    key: 'bonusBa',
    label: 'BA Bonus',
    type: 'currencySign',
  },
  {
    key: 'baPayout',
    label: 'BA Payout',
    type: 'currencySign',
  },
  {
    key: 'outfitCosts',
    label: 'Outfit',
    type: 'currencySign',
  },
  {
    key: 'permitCostsH2h',
    label: 'Permit (H2H)',
    type: 'currencySign',
  },
  {
    key: 'permitCostsD2d',
    label: 'Permit (D2D)',
    type: 'currencySign',
  },
  {
    key: 'travelCosts',
    label: 'Travel',
    type: 'currencySign',
  },
  {
    key: MINIMUM_MISSION_LIMIT,
    label: 'Minimum Mission Limit',
    type: 'number',
  },
  {
    key: WEEKLY_MISSION_LIMIT,
    label: 'Max Mission pw',
    type: 'number',
  },

  {
    key: 'flyerPackH2h',
    label: 'H2H Flyer Pack',
    type: 'number',
  },
  {
    key: 'flyerPackD2d',
    label: 'D2D Flyer Pack',
    type: 'number',
  },
]

export const CITY_SETTINGS_PRE_HEADERS = [
  {
    label: ' ',
    colSpan: 1,
  },
  {
    label: 'Channels',
    colSpan: 2,
  },
  {
    label: 'Costs',
    colSpan: 8,
  },
  {
    label: 'Limits',
    colSpan: 5,
  },
]

export const CHANNEL_SETTINGS_HEADERS = [
  {
    key: 'Status',
    label: 'Channel',
  },
  // {
  //   key: 'enabledChannelBroadAreas',
  //   label: 'H2H Broad Areas',
  // },
  {
    key: 'enabledChannelPreciseLocations',
    label: 'H2H Precise Locations',
  },
  {
    key: 'enabledChannelLetterbox',
    label: 'D2D',
  },
]
